import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import CategoriesList from "./CategoriesList";
import axios from 'axios';

type CategoryType = {
    id: number;
    name: string;
    slug: string;
}

const BlogCategories: React.FC = (props) => {

    const [cats, setCats] = useState<CategoryType[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const fetchCats = async () => {
        setIsLoading(true);
        setError('');
        try {
            const { data } = await axios.get('blog/categories');
            setCats(data.data);
        } catch (error: any) {
            setError(error.message);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        fetchCats();
    }, []);

    let content: any = "No Categories Found";

    if( cats.length ) {
        content = <CategoriesList cats={cats} />
    }

    return (
        <div>
            <div>{content}</div>
        </div>
    );
}

export default BlogCategories;

if (document.getElementById('blog-categories')) {
    ReactDOM.render(<BlogCategories />, document.getElementById('blog-categories'));
}
